// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Autocomplete,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    InputLabel,
    Select,
    MenuItem,
    Card,
} from '@mui/material'

import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import MsiDatagridCheckbox from '../../../components/custom/MsiDatagridAutoCheckbox';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import { createRoot } from 'react-dom/client';
import { useToast } from '../../../components/ToastProvider';
import AddSupplierDialog from '../supplier/component/AddSupplierDialog'
import DialogDPVendor from '../../../components/acc/DialogDPVendor'

export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    // ** State
    const [tabs, setTabs] = useState<string>("4")

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    const [sysdoctagId, setSysdoctagId] = useState<string>('')

    const [selectedList, setSelectedList] = useState<any[]>([])
    const [selectedPR, setSelectedPR] = useState<any>(null)
    const [listData, setListData] = useState<any[]>([])
    const [listHistoryPembatalan, setListHistoryPembatalan] = useState<any[]>([])
    const [listSupplier, setListSupplier] = useState<any[]>([])
    const [openAddSupplier, setOpenAddSupplier] = useState(false);
    const [isOto, setIsOto] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [dialogMode, setDialogMode] = useState<string>('add')
    const [selectedData, setSelectedData] = useState<any>(null)

    const [openPOMulti, setOpenPOMulti] = useState(false)
    const [listPOMulti, setListPOMulti] = useState<any[]>([])

    useEffect(() => {
        setSelectedList([]);
        setSelectedPR(null);
        getData(tabs)
        getListSupplier()

        const getUserOto = (sysdoctag_id: any) => {
            const url = apiUrl.apiUrl + '/system/user/cek-oto'
            axios
                .get(url, {
                    params: { sysdoctag_id: sysdoctag_id },
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success) {
                        const data = response.data.data
                        setIsOto(data)
                    } else {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: response.data.message,
                            icon: 'error'
                        })
                    }
                })
        }
        getUserOto(4)

        const getDoctag = () => {
            const url = apiUrl.apiUrl + '/system/doctag/list-combo'
            axios
                .get(url, {
                    params: {
                        syscabang_id: 1,
                        sysmenu_id: 39
                    },
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success) {
                        const data = response.data.data
                        setListDoctag(data)
                    } else {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: response.data.message,
                            icon: 'error'
                        })
                    }
                })
        }

        getDoctag();
    }, [])

    const navigate = useNavigate();

    const getListSupplier = () => {
        const url = apiUrl.apiUrl + '/purchasing/inquiry/list-vendor'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSupplier(data)
                } else {
                    showToast(response.data.message, "error");
                }
            })

    }

    const getData = (mode: any) => {
        setSelectedList([]);
        setSelectedPR(null);
        showToast("Loading", "loading");
        let url = apiUrl.apiUrl + '/purchasing/po/list-po'
        axios
            .get(url, {
                params: {
                    tglAwal: tglAwal,
                    tglAkhir: tglAkhir,
                    mode: mode,
                    doctag: sysdoctagId
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    hideToast()
                } else {
                    showToast(response.data.message, "error");
                }
            })
    }

    const getRekapDP = () => {
        setListData([])
        showToast("Loading", "loading");
        let url = apiUrl.apiUrl + '/purchasing/po/rekap-dp'
        axios
            .get(url, {
                params: {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    hideToast()
                } else {
                    showToast(response.data.message, "error");
                }
            })
    }

    const historyPembatalanPR = () => {
        setListHistoryPembatalan([])
        showToast("Loading", "loading");
        let url = apiUrl.apiUrl + '/purchasing/po/history-pembatalan-pr'
        axios
            .get(url, {
                params: {
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListHistoryPembatalan(data)
                    hideToast()
                } else {
                    showToast(response.data.message, "error");
                }
            })
    }

    const getDetail = (id: any) => {

        let url = apiUrl.apiUrl + '/acc/dp-vendor/detail/' + id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    setDialogMode('edit')
                    setSelectedData(data)
                    setOpenDialog(true)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        if (newValue == '5') {
            getRekapDP()
        } else if (newValue == '6') {
            historyPembatalanPR()
        } else {
            getData(newValue)
        }
    }

    const onBatalPO = (pid: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin batal PO ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Batal'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/purchasing/po/batal-po/' + pid
                axios
                    .delete(url, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData(tabs)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>
                    <Tooltip title="Lihat Detail" placement="top">
                        <Box>
                            <IconButton onClick={() => navigate('/purchasing/purchase-order/detail/' + row.id_po)}>
                                <Icon icon="mdi:search" color="#1976d2" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    <Tooltip title="Print" placement="top">
                        <Box>
                            <IconButton onClick={() => window.open(apiUrl.baseUrl + '/purchasing/purchase-order/preview/' + row.id_po, '_blank')}>
                                <Icon icon="mdi:file-pdf" color="#1db124" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    {
                        row.is_aktif === 0 ? (
                            <Tooltip title="Batalkan PR" placement="top">
                                <Box>
                                    <IconButton onClick={() => onBatalPO(row.id)}>
                                        <Icon icon="mdi:trash" color="#d32f2f" />
                                    </IconButton>
                                </Box>
                            </Tooltip>
                        ) : null
                    }
                </Box>
            ),

        },
    ];

    const actionPo = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>
                    <Tooltip title="Lihat Detail" placement="top">
                        <Box>
                            <IconButton onClick={() => navigate('/purchasing/purchase-order/detail/' + row.id)}>
                                <Icon icon="mdi:search" color="#1976d2" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    <Tooltip title="Print" placement="top">
                        <Box>
                            <IconButton onClick={() => window.open(apiUrl.baseUrl + '/purchasing/purchase-order/preview/' + row.id, '_blank')}>
                                <Icon icon="mdi:file-pdf" color="#1db124" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    {
                        row.is_aktif === 0 ? (
                            <Tooltip title="Batalkan PO" placement="top">
                                <Box>
                                    <IconButton onClick={() => onBatalPO(row.id)}>
                                        <Icon icon="mdi:trash" color="#d32f2f" />
                                    </IconButton>
                                </Box>
                            </Tooltip>
                        ) : null
                    }
                </Box>
            ),

        },
    ];

    const convertComponent = [
        {
            key: "id_pr",
            renderCell: (row: any) => (
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                        navigate('/purchasing/purchase-request/detail/' + row.value)
                    }
                >
                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                        {row.value}
                    </Typography>
                </div>
            ),
        },
        {
            key: "id_gr",
            renderCell: (row: any) => (
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        row.value
                            ?.split(',')
                            .map((gr: string) => gr.trim())
                            .forEach((gr: string) => {

                                window.open(
                                    '/purchasing/good-receipt/detail/' +
                                    encodeURIComponent(gr),
                                    '_blank'
                                )

                            })
                    }}
                >
                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                        {row.value}
                    </Typography>
                </div>
            ),
        },
        {
            key: "ket_purchasing",
            renderCell: (row: any) => (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        width: '100%'
                    }}
                >
                    {/* tampilkan value lama */}
                    <Typography variant="body2" sx={{ flexGrow: 1 }}>
                        {row.value || '-'}
                    </Typography>

                    {/* tombol edit */}
                    <IconButton
                        size="small"
                        color="warning"
                        onClick={() => {
                            Swal.fire({
                                title: 'Edit Keterangan Purchasing',
                                input: 'textarea',
                                inputLabel: 'Keterangan',
                                inputValue: row.value || '',
                                inputPlaceholder: 'Masukkan keterangan...',
                                showCancelButton: true,
                                confirmButtonText: 'Simpan',
                                cancelButtonText: 'Batal',
                                preConfirm: (value) => {
                                    if (!value) {
                                        Swal.showValidationMessage(
                                            'Keterangan wajib diisi'
                                        )
                                    }
                                    return value
                                }
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    const url =
                                        apiUrl.apiUrl +
                                        '/purchasing/po/keterangan-purchasing/' +
                                        row.row.data.id

                                    axios
                                        .post(
                                            url,
                                            {
                                                keterangan: result.value
                                            },
                                            {
                                                headers: {
                                                    Authorization: `Bearer ${token}`
                                                }
                                            }
                                        )
                                        .then((response) => {
                                            if (response.data.success) {
                                                showToast(response.data.message, 'success')
                                                getData(tabs)
                                            } else {
                                                showToast(response.data.message, 'error')
                                            }
                                        })
                                        .catch((error) => {
                                            showToast(error.message, 'error')
                                        })
                                }
                            })
                        }}
                    >
                        <Icon icon="mdi:pencil" />
                    </IconButton>
                </Box>
            ),
        },
    ];

    const daftarPO = [
        {
            key: 'dp_id',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {row.data.is_aktif == 1 ? (
                            <>
                                {row.data.dp_id == null ? (
                                    <Button
                                        variant="contained"
                                        color="warning"
                                        startIcon={<Icon icon="mdi:file-document-plus" />}
                                        onClick={() => {
                                            setDialogMode('add-from-list')
                                            setSelectedData(row.data)
                                            setOpenDialog(true)
                                        }}
                                    >
                                        Buat DP
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        color="success"
                                        startIcon={<Icon icon="mdi:cash-fast" />}
                                        onClick={() => {
                                            getDetail(row.data.dp_id)
                                        }}
                                    >
                                        Bayar DP <br />
                                        {row.data.dp_id}
                                    </Button>
                                )}
                            </>
                        ) : (
                            <Typography variant='body2' sx={{ fontWeight: '500' }}>
                                <i>PO Belum Aktif</i>
                            </Typography>
                        )}
                    </Box>
                )
            }
        }
    ];

    const rekapPengajuan = [
        {
            key: 'dp_id',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>

                        {row.data.dp_id == null ? (
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<Icon icon="mdi:file-document-plus" />}
                                onClick={() => {
                                    setDialogMode('add-from-list')
                                    setSelectedData(row.data)
                                    setOpenDialog(true)
                                }}
                            >
                                Buat DP
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:cash-fast" />}
                                onClick={() => {
                                    getDetail(row.data.dp_id)
                                }}
                            >
                                Bayar DP <br />
                                {row.data.dp_id}
                            </Button>
                        )}
                    </Box>
                )
            }
        }
    ];

    const historyPembatalan = [
        {
            key: "nama_barang",
            renderCell: (row: any) => (
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                        navigate('/mm/master-barang/detail/' + row.data.mmbarang_id)
                    }
                >
                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                        {row.value}
                    </Typography>
                </div>
            ),
        },
    ];

    const handleSelection = (data: any) => {
        setSelectedList(data.selectedRowsData)
        setSelectedPR(JSON.stringify(data.selectedRowsData))
    };

    const getSupplier = async (customData?: any[]) => {
        let options = listSupplier;
        let selectedSupplier: any = null;

        Swal.fire({
            title: 'Pilih Supplier',
            html: `<div id="swal-autocomplete"></div>`,
            showCancelButton: true,
            confirmButtonText: 'Simpan',
            cancelButtonText: 'Batal',
            willOpen: () => {
                const btn = Swal.getConfirmButton();
                if (btn) btn.disabled = true; // Disable tombol awalnya
            },
            didOpen: () => {
                const root = createRoot(document.getElementById('swal-autocomplete')!);

                root.render(
                    <Autocomplete
                        options={options}
                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                        onChange={(event, newValue) => {
                            selectedSupplier = newValue;

                            const btn = Swal.getConfirmButton();
                            if (btn) {
                                btn.disabled = !newValue; // aktifkan hanya jika pilih supplier
                            }
                        }}
                        renderOption={(props: any, option: any) => (
                            <li {...props} key={option.id}>
                                {option.nama}
                            </li>
                        )}
                        getOptionLabel={(option: any) => option.nama}
                        renderInput={(params: any) => (
                            <TextField
                                {...params}
                                label='Pilih Supplier'
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                );
            },
            preConfirm: () => {
                if (!selectedSupplier) {
                    Swal.showValidationMessage("Supplier wajib dipilih");
                    return false;
                }

                return {
                    detail: customData,
                    pbsupplier_id: selectedSupplier.id,
                    supplier: selectedSupplier.nama,
                    eta: selectedSupplier.eta,
                    syscabang_id: 1,
                    pbinquiry_id: null,
                };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                savePoMulti(result.value);
            }
        });
    }


    const savePoMulti = (data: any) => {
        showToast("Loading", "loading");
        const send = {
            detail: selectedPR,
            pbsupplier_id: data.pbsupplier_id,
            supplier: data.supplier,
            eta: data.eta,
            syscabang_id: 1,
            pbinquiry_id: data.pbinquiry_id
        }

        let url = apiUrl.apiUrl + '/purchasing/po/add-po-multi'

        axios
            .post(url, send, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, "success");
                    navigate('/purchasing/purchase-order/detail/' + response.data.data);

                } else {
                    showToast(response.data.message, "error");
                }
            })
            .catch(error => {
                showToast(error.message, "error");
            })
    }

    const hapusRequest = () => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Buat'
        }).then(result => {
            if (result.isConfirmed) {
                showToast("Loading", "loading");
                const send = {
                    detail: JSON.stringify(selectedList),
                }

                let url = apiUrl.apiUrl + '/purchasing/po/hapus-multi'

                axios
                    .post(url, send, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            showToast(response.data.message, "success");
                            getData(tabs)
                        } else {
                            showToast(response.data.message, "error");
                        }
                    })
                    .catch(error => {
                        showToast(error.message, "error");
                    })
            }
        })
    }

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/acc/dp-vendor/delete-dp/' + row.id
        axios
            .post(url, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getData(tabs);
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const ActionButtonsRekapPengajuan = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Print",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/acc/dp-vendor/pdf/' + row.id, '_blank')
            },
            {
                title: "Hapus",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionRekapPengajuan = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 120,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsRekapPengajuan
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    const totalPengajuan = listData.reduce(
        (sum, item) => sum + Number(item.dp || 0),
        0
    );

    const totalDicairkan = listData.reduce(
        (sum, item) => sum + Number(item.dp_terbayar || 0),
        0
    );

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='PURCHASE ORDER' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>

                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <InputLabel id='doctag-label'>Jenis Dokumen</InputLabel>
                                    <Select
                                        labelId='doctag-label'
                                        label='Jenis Dokumen'
                                        value={sysdoctagId}
                                        onChange={(e) => setSysdoctagId(e.target.value)}
                                    >
                                        {/* Option Semua */}
                                        <MenuItem value={0}>Semua Data</MenuItem>

                                        {/* List dari API */}
                                        {listDoctag.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.nama}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData(tabs)}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='2' label='PO Belum Aktif' />
                            <Tab value='4' label='Daftar PO' />
                            <Tab value='1' label='Daftar PO By Barang' />
                            <Tab value='0' label='Outstanding PR' />
                            <Tab value='3' label='Progress PO' />
                            <Tab value='5' label='Rekap Pengajuan Dana' />
                            <Tab value='6' label='History Pembatalan PR' />
                        </TabList>
                        <TabPanel value='2'>
                            <MsiDatagrid array={listData} actions={actionData} hiddenColumns={['aktif', 'id_po']}
                                rowStyleRules={[
                                    { field: 'aktif', operator: '==', value: 0, color: '#ff8787ff' },
                                ]}
                                customRender={convertComponent}
                                convertRupiah={['harga_unit', 'total_exclude']}
                            />
                        </TabPanel>
                        <TabPanel value='4'>
                            <MsiDatagrid array={listData} hiddenColumns={['is_aktif', 'default_dp', 'default_dp_pesan', 'pbsupplier_id']} actions={actionPo}
                                customRender={daftarPO}
                                rowStyleRules={[
                                    { field: 'is_aktif', operator: '==', value: 0, color: '#ff8787ff' },
                                ]}
                                convertRupiah={['total', 'dp', 'dp_terbayar']}
                            />
                        </TabPanel>
                        <TabPanel value='1'>
                            <MsiDatagrid array={listData} actions={actionData} hiddenColumns={['aktif']}
                                rowStyleRules={[
                                    { field: 'aktif', operator: '==', value: 0, color: '#ff8787ff' },
                                ]}
                                customRender={convertComponent} />
                        </TabPanel>
                        <TabPanel value='0'>
                            {selectedList.length > 0 ? (
                                <Box
                                    sx={{
                                        gap: 2,
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        p: theme => theme.spacing(2, 0, 0, 0)
                                    }}
                                >
                                    <Button
                                        variant='outlined'
                                        onClick={() => {
                                            const mapped = selectedList.map((item: any) => ({
                                                ...item,
                                                qty_po: Math.max(
                                                    (item.qty_pr || item.qty || 0) - (item.qty_po || 0),
                                                    0
                                                )
                                            }))

                                            setListPOMulti(mapped)
                                            setOpenPOMulti(true)
                                        }}
                                        startIcon={<Icon icon='mdi:text-box-check-outline' />}
                                    >
                                        Buat PO Multi
                                    </Button>
                                    {isOto === 0 ? ('') : (
                                        <Button
                                            variant='outlined'
                                            color='error'
                                            onClick={() => {
                                                hapusRequest()
                                            }}
                                            startIcon={<Icon icon='mdi:cancel' />}
                                        >
                                            Batalkan Permintaan
                                        </Button>
                                    )}
                                    <Button
                                        variant='outlined'
                                        onClick={() => setOpenAddSupplier(true)}
                                        color='success'
                                        startIcon={<Icon icon='mdi:account-plus' />}
                                    >
                                        Tambah Supplier
                                    </Button>
                                </Box>
                            ) : null}
                            <MsiDatagridCheckbox array={listData} customRender={convertComponent} handleSelection={handleSelection} hiddenColumns={['mmbarang_id']} />
                        </TabPanel>
                        <TabPanel value='3'>
                            <MsiDatagrid array={listData} actions={actionData} customRender={convertComponent} />
                        </TabPanel>
                        <TabPanel value='5'>
                            <Grid container spacing={2} mb={2}>
                                <Grid item xs={12} md={6}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="subtitle2" color="text.secondary">
                                                Total Nilai Pengajuan
                                            </Typography>
                                            <Typography variant="h5" fontWeight="bold">
                                                Rp {totalPengajuan.toLocaleString('id-ID')}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="subtitle2" color="text.secondary">
                                                Total Dicairkan
                                            </Typography>
                                            <Typography variant="h5" fontWeight="bold">
                                                Rp {totalDicairkan.toLocaleString('id-ID')}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                            <MsiDatagrid array={listData}
                                hiddenColumns={['id']}
                                customRender={rekapPengajuan}
                                actions={actionRekapPengajuan}
                                convertRupiah={['total', 'dp', 'dp_terbayar']}
                            />
                        </TabPanel>
                        <TabPanel value='6'>
                            <MsiDatagrid array={listHistoryPembatalan}
                                hiddenColumns={['id', 'pbpr_id', 'mmbarang_id']}
                                customRender={historyPembatalan}
                            />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
            <AddSupplierDialog
                open={openAddSupplier}
                onClose={() => setOpenAddSupplier(false)}
                onSuccess={() => {
                    // DI SINI: setelah supplier berhasil ditambah
                    getListSupplier();
                }}
            />

            <DialogDPVendor
                key={selectedData?.id ?? 'add-from-list'}
                open={openDialog}
                mode={dialogMode}
                data={selectedData}
                doc_id={selectedData?.id}
                doc_type={'pbpo'}
                onClose={() => {
                    setOpenDialog(false)
                    getData(tabs)
                    setTabs(tabs)
                }}
            />
            <Dialog open={openPOMulti} onClose={() => setOpenPOMulti(false)} maxWidth='md' fullWidth>
                <DialogTitle>Buat PO Multi</DialogTitle>

                <DialogContent>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Barang</TableCell>
                                <TableCell>Qty PR</TableCell>
                                <TableCell>Qty PO</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {listPOMulti.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row.nama_item}</TableCell>
                                    <TableCell>{row.qty_pr || row.qty}</TableCell>

                                    <TableCell width={150}>
                                        <TextField
                                            type='number'
                                            fullWidth
                                            value={row.qty_po}
                                            onChange={e => {
                                                const newData = [...listPOMulti]
                                                newData[index].qty_po = Number(e.target.value)
                                                setListPOMulti(newData)
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenPOMulti(false)}>Batal</Button>

                    <Button
                        variant='contained'
                        onClick={() => {
                            // 🔥 filter hanya yg ada qty_po
                            const finalData = listPOMulti.filter(x => x.qty_po > 0)

                            // optional validasi
                            if (finalData.length === 0) {
                                setOpenPOMulti(false)
                                Swal.fire({
                                    title: 'Peringatan',
                                    text: 'Qty PO tidak boleh kosong',
                                    icon: 'warning'
                                }).then(() => {
                                    setOpenPOMulti(true)
                                })
                                return
                            }

                            setSelectedPR(JSON.stringify(finalData))
                            setOpenPOMulti(false)

                            // lanjut ke supplier
                            getSupplier(finalData)
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
